import { styled } from 'styled-components';

export const CheckboxWrap = styled.div`
  display: inline-flex;
  flex-direction: column;
`;
